import React from "react";
//#region types
import { SupportCaseTopCardParticipantsProps } from "models/propTypes/supportIssuePropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { Profiles } from "components/common";
//#endregion
import { useSupportService } from "serviceHooks";
import { LocalizationHelperInstance } from "utils/helpers";

const SupportCaseTopCardParticipants: React.FC<SupportCaseTopCardParticipantsProps> = ({ supportIssue }) => {
  const supportService = useSupportService();
  // A case owned by the byrå does not involve Wint at all, so no Wint avatar there.
  const isWintCounterpart = !supportIssue.isOwnedByAgency;
  const participantCount = supportService.getConversationParticipantCount(supportIssue);

  return supportIssue.participants && supportIssue.participants.length > 1 ? (
    <Grid container direction="row" flexWrap="nowrap" columnGap={1} alignItems="center">
      <Grid item>{`${participantCount} ${LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Common.Participants
      )}`}</Grid>
      <Grid item>
        <Profiles.MultiProfiles
          maxProfiles={4}
          showWint={isWintCounterpart}
          profiles={supportIssue.participants!.map((p) => ({ id: p.id, name: p.name ?? "" }))}
        />
      </Grid>
    </Grid>
  ) : (
    <></>
  );
};

export default SupportCaseTopCardParticipants;
